export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '',
  appId: 'zSHR',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '0.9.19'
};